/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React from 'react';

const getStyle = (props) => {
    let baseClass = "alert ";
    if(props.message.msgError) {
        baseClass += "alert-danger";
    } else {
        baseClass += "alert-primary";
    }
    return baseClass + " text-center"
}

const Message = props => {

    return (
        <div id="message-div" style={{marginTop:'1rem'}} className={getStyle(props)} role="alert">
            {props.message.msgBody}
        </div>
    )
}

export default Message;
